import { createFileRoute } from '@tanstack/react-router';
import { productPhotoSlot } from '@/app/commercial/slots';
import { ProductEditor } from '@/modules/products/public';
import { RequirePermission } from '@/modules/identity/public';

export const Route = createFileRoute('/_admin/produtos/novo')({
  component: function NewProductRoute() {
    const navigate = Route.useNavigate();
    return (
      <RequirePermission anyOf={['produtos.editar']}>
        <ProductEditor
          canEdit
          imageSlot={productPhotoSlot}
          onBack={() => navigate({ to: '/produtos' })}
          onSaved={(e) =>
            navigate({ to: '/produtos/$productId', params: { productId: e.id }, replace: true })
          }
          onDeleted={() => navigate({ to: '/produtos' })}
        />
      </RequirePermission>
    );
  },
});
